export default "__VITE_ASSET__c14ddc44__"